import React, { memo } from 'react';
import { Box, Typography, Theme } from '@mui/material';
import classNames from 'classnames';

import { IProduct } from '../../../types/Product.types';

const styles = {
  productTitle: {
    fontWeight: 'bolder',
    color: ({ palette }: Theme) => palette.primary.main,
  },
} as const;

export interface IDelayedGiftCardPreviewProps {
  product: IProduct;
}

const DelayedGiftCardPreview = ({ product }: IDelayedGiftCardPreviewProps) => (
  <Box>
    <Box mb={1} display="flex" justifyContent="center" alignItems="center">
      <Typography className={classNames('H4-Dark-Bold', 'textPrimary-ie')}>Your gift card is in process</Typography>
    </Box>
    <Box display="flex" justifyContent="center" alignItems="center">
      <Typography sx={styles.productTitle}>{product.name}</Typography>
    </Box>
    {product.image && (
      <Box display="flex" justifyContent="center" alignItems="center">
        <img src={product.image} alt="" width={150} height={150} />
      </Box>
    )}
    <Box mt={2} display="flex" justifyContent="center" alignItems="center">
      <Typography className={classNames('Body-Regular-Center-Static', 'textPrimary-ie')}>
        Once gift card is ready,
        <br />
        you will receive an email with the redemption instructions.
      </Typography>
    </Box>
  </Box>
);

export default memo(DelayedGiftCardPreview);
